import { Skeleton } from '@/components/ui'

export const DocumentSkeleton = () => (
  <div className="flex flex-1 gap-4 min-h-0">
    <Skeleton className="flex-1 rounded-lg" />
    <Skeleton className="flex-1 rounded-lg" />
  </div>
)
